











































































































import WidgetMixins from '../../../../mixins/WidgetMixins';
import Component, { mixins } from 'vue-class-component';
import { loadView, loadWidget } from '@/utils/helpers';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import { PayloadState } from '@/types/types';

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { numeric, required } from 'vee-validate/dist/rules';
import { debounce } from 'lodash';
import moment from 'moment/moment';
extend('required', {
  ...required,
  message: 'Field is required',
});
extend('numeric', {
  ...numeric,
  message: 'Field accept only numbers',
});
const productsModule = namespace('products');
const customersModule = namespace('customers');
const authModule = namespace('auth');

@Component({
  name: 'TopUpAccountDialog',
  components: {
    EmptyPage: loadWidget('pages/EmptyPage'),
    ValidationObserver,
    ValidationProvider,
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
  },
})
export default class TopUpAccountDialog extends mixins(WidgetMixins) {
  @Getter('getResetFormState') resetFormState!: boolean;
  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean; // button loading
  @Prop({ default: false }) link!: string;

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;

  startDate: string | null = moment()
    .subtract(1, 'week')
    .format('YYYY-MM-DD');
  endDate: string | null = moment().format('YYYY-MM-DD');

  @Emit('save')
  saveData() {
    return {
      loading: {
        idx: 'add',
        state: false,
      },
      query: {
        startDate: this.startDate,
        endDate: this.endDate,
      },
    };
  }

  @Emit('actions')
  close(): PayloadState {
    return {
      idx: 'add',
      state: false,
    };
  }
}
